import { createRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/sites/$siteId',
  validateSearch: z.object({
    locale: z.string().optional(),
    preview: z.boolean().optional(),
    changes: z.boolean().optional(),
  }).parse,
  component: Outlet,
});
